goog.module('yext.developerapps.common.Filter');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
/** @suppress {extraRequire} */
goog.require('yext.plugins.multiselect');

/**
 * @constructor
 */
const Filter = function($ctxt) {
  this.$ctxt = $ctxt;
};

Filter.prototype.init = function() {
  this.bindFilterChange();
  this.bindDeleteFilter();
  this.initializeExistingFilters();
};

Filter.prototype.bindFilterChange = function() {
  var filter = this;
  this.$ctxt.on('change', '.js-filter-type', function() {
    filter.changeFilter($(this));
  });
};

Filter.prototype.bindDeleteFilter = function() {
  var filter = this;
  this.$ctxt.find('.js-workflow-filters').on('click', '.js-delete-button', function() {
    $(this).closest('.js-workflow-filter').remove();
    filter.disableFilterOptions();
    $(filter).trigger('filterUpdated');
  });
};

Filter.prototype.initializeExistingFilters = function() {
  this.$ctxt.find('.js-existing-filter-data').each(function() {
    var $this = $(this);
    var $filter = $this.closest('.js-workflow-filter');
    $filter.find('.js-filter-type').trigger('change');
    if ($this.data('type') == 'SITE_INCLUDES') {
      var data = $this.val().split(',');
      var checked = 0;
      var siteName = '';
      $filter.find('.js-filter-value').find('option').each(function() {
        if (data.indexOf($(this).val()) != -1) {
          $(this).prop('selected', true);
          checked++;
          siteName = $(this).text();
        }
      });
      if (checked != 1) {
        siteName = yext.msgn('1 site selected', '{0} sites selected', checked);
      }
      $filter.find('.js-filter-value span').text(siteName);
    } else if ($this.data('type') == 'FOLDER_INCLUDES') {
      var data = $this.val().split(',');
      var checked = 0;
      var folderName = '';
      $filter.find('.js-filter-value').find('option').each(function() {
        if (data.indexOf($(this).val()) != -1) {
          $(this).prop('selected', true);
          checked++;
          folderName = $(this).text();
        }
      });
      if (checked != 1) {
        folderName = yext.msgn('1 folder selected', '{0} folders selected', checked);
      }
      $filter.find('.js-filter-value span').text(folderName);
    } else {
      $filter.find('.js-filter-value').val($this.val());
    }
  });
};

Filter.prototype.addFilter = function() {
  var $filter = this.$ctxt.find('.js-workflow-filter-template')
    .clone()
    .removeClass('js-workflow-filter-template')
    .show();
  this.$ctxt.find('.js-add-filter-btn').before($filter);
  $filter.find('.js-filter-type').trigger('change');
  $(this).trigger('filterUpdated');
};

Filter.prototype.changeFilter = function($filterSelect) {
  var filterType = $filterSelect.find('option:checked').data('input-type');
  this.disableFilterOptions();
  var templateClass = 'js-' + filterType + '-filter-template';
  var $filter = this.$ctxt.find('.' + templateClass).clone().removeClass(templateClass);
  if (filterType == 'multiselect') {
    this.addMultiselectFilter($filter);
  } else if (filterType == 'folder-multiselect') {
    this.addFolderMultiselectFilter($filter);
  }
  var $row = $filterSelect.closest('.js-workflow-filter');
  $row.find('.js-filter').remove();
  $filter.show().insertAfter($row.find('.js-filter-dropdown'));
  $(this).trigger('filterUpdated');
};

Filter.prototype.disableFilterOptions = function() {
  $('.js-filter-type option').prop('disabled', false);
  $('.js-filter-type:visible option:selected').each(function() {
    var $option = $(this);
    if (this.value != 'REVIEW_CONTENT' && this.value != '') {
      $('.js-filter-type option[value=' + this.value + ']')
        .filter(function() {
          return !$(this).is($option);
        })
        .prop('disabled', true);
    }
  });
};

Filter.prototype.addMultiselectFilter = function($filter) {
  $filter.find('select').multiselect({
    hideFooter: true,
    title: yext.msg('0 sites selected'),
  });

  var filter = this;
  $filter.on('change', 'input', function() {
    filter.getMultiselectOption($filter, this.value)[0].selected = this.checked;
    var selectedSites = 0;
    var siteName = '';
    $filter.find('input:checked').each(function() {
      selectedSites++;
      siteName = filter.getMultiselectOption($filter, this.value).text();
    });
    if (selectedSites != 1) {
      siteName = yext.msg('{0} sites selected', selectedSites);
    }
    $filter.find('div.multiselect > button > span').text(siteName);
  });
};

Filter.prototype.addFolderMultiselectFilter = function($filter) {
  $filter.find('select').multiselect({
    hideFooter: true,
    title: yext.msg('0 folders selected'),
  });

  var filter = this;
  $filter.on('change', 'input', function() {
    filter.getMultiselectOption($filter, this.value)[0].selected = this.checked;
    var selectedFolders = 0;
    var folderName = '';
    $filter.find('input:checked').each(function() {
      selectedFolders++;
      folderName = filter.getMultiselectOption($filter, this.value).text();
    });
    if (selectedFolders != 1) {
      folderName = yext.msg('{0} folders selected', selectedFolders);
    }
    $filter.find('div.multiselect > button > span').text(folderName);
  });
};

Filter.prototype.getMultiselectOption = function($filter, value) {
  return $filter.find('select option[value=' + value + ']');
};

exports = Filter;
